"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _Style = require("../../style/Style");
var _lesson = require("../../store/lesson");
var _Lesson = require("../../model/Lesson");
var _UserLesson = require("../../model/UserLesson");
var _user = require("../../store/user");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//import { Button } from '@mui/base';
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const [lesson, setLesson] = (0, _react.useState)(new _Lesson.Lesson());
  const [lastTime, setLastTime] = (0, _react.useState)(0);
  const [userLesson, setUserLesson] = (0, _react.useState)(new _UserLesson.UserLesson());
  const [isStarted, setIsStarted] = (0, _react.useState)(false);
  const [isEnd, setIsEnd] = (0, _react.useState)(false);
  const videoRef = (0, _react.useRef)(null);
  const lastUpdateTime = new Date();
  const {
    isLoading,
    setIsLoading,
    setToastText,
    setToastOpen,
    onLoggedIn,
    setOnLoggedIn
  } = (0, _common.useCommonStore)();
  const {
    currentUser
  } = (0, _user.useUserStore)();
  const {
    lessons,
    fetchLessons,
    deleteLesson,
    errors
  } = (0, _lesson.useLessonStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      if (!currentUser || !currentUser.id) {
        setToastText('ユーザー情報が見つかりませんでした。再度ログインしてください。');
        setToastOpen(true);
        setLocation('/login');
        return;
      }
      if (!currentUser.companyId) {
        setToastText('ユーザー情報位問題があります。再度ログインしてください。');
        setToastOpen(true);
        setLocation('/login');
        return;
      }
      if (!props.courseId) {
        setLocation('/courses');
        setToastText('コースが見つかりませんでした。');
        setToastOpen(true);
        return;
      }
      if (!props.lessonId) {
        setLocation(`/course/detail/${props.courseId}`);
        setToastText('教材が見つかりませんでした。');
        setToastOpen(true);
        return;
      }
      setIsLoading(true);
      const newLesson = await _Lesson.Lesson.getByID(props.lessonId);
      await newLesson.fetchVideoPreviewUrl();
      const currentUserLesson = await _UserLesson.UserLesson.getByID(currentUser.id, props.lessonId);
      if (!currentUserLesson.id) {
        userLesson.init(currentUser.id, currentUser.companyId, props.courseId, props.lessonId);
      }
      setUserLesson(currentUserLesson);
      setLesson(newLesson);
      setIsLoading(false);
    })();
  }, []);
  (0, _react.useEffect)(() => {
    const video = videoRef.current;
    if (!video) {
      return;
    }
    const handleTimeUpdate = () => {
      setIsEnd(false);
      const currentTime = Math.round(video.currentTime);
      if (userLesson.watchedTime <= currentTime && currentTime > lastTime + 1) {
        // 早送りされた場合、元の位置に戻す
        video.currentTime = lastTime;
        setToastText('未視聴箇所への早送りはできません。');
        setToastOpen(true);
      } else {
        setLastTime(currentTime); // 再生位置を記録
        console.log(userLesson.watchedTime + ' ' + currentTime);
        if (userLesson.watchedTime < currentTime) {
          userLesson.watchedTime = currentTime;
        } // 未受講で動画視聴が開始された時
        if (userLesson.status === _UserLesson.UserLesson.STATUS_NOT_STARTED) {
          userLesson.status = _UserLesson.UserLesson.STATUS_IN_PROGRESS;
          userLesson.startedAt = new Date();
        } // 最短でも1秒おきに更新
        if (lastUpdateTime.getTime() + 1000 < new Date().getTime()) {
          userLesson.updateFirebase();
          lastUpdateTime.setTime(new Date().getTime());
        }
      }
    };
    video.addEventListener('timeupdate', handleTimeUpdate);
    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [lastTime]);
  const restart = () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }
    video.currentTime = 0;
    setLastTime(0);
    video.play();
    setIsStarted(true);
  };
  const startWatchedTime = () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }
    video.currentTime = userLesson.watchedTime;
    setLastTime(userLesson.watchedTime);
    video.play();
    setIsStarted(true);
  };
  const pause = () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }
    video.pause();
  };
  const toExam = () => {
    console.log(userLesson);
    if (!window.confirm(`単元「${lesson.name}」の修了テストを開始しますか？`)) return;
    setLocation(`/course/${lesson.courseId}/lesson/${userLesson.lessonId}/exam`);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    spacing: 2,
    ...stylex.props(_Style.wrapper.main),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
      ...stylex.props(_Style.buttonStyle.secondary),
      onClick: () => {
        window.history.back();
      },
      children: "\u5358\u5143\u4E00\u89A7\u306B\u623B\u308B"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "row",
      alignItems: 'center',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.chipStyle.common, userLesson.isNotStarted && _Style.chipStyle.inactive, userLesson.isInProgress && _Style.chipStyle.during, userLesson.isCompleted && _Style.chipStyle.active),
        children: userLesson.status
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: lesson.name
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ...stylex.props(_Style.textStyle.paragraph1),
      children: lesson.detail
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: ["\u53D7\u8B1B\u958B\u59CB\u65E5\u6642: ", userLesson.startedAtText]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: ["\u53D7\u8B1B\u5B8C\u4E86\u65E5\u6642: ", userLesson.completedAtText]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ...stylex.props(_Style.wrapper.video),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("video", {
        ref: videoRef,
        controls: true,
        ...stylex.props(_Style.videoStyle.main),
        onEnded: async () => {
          setIsEnd(true);
          if (userLesson.status === _UserLesson.UserLesson.STATUS_COMPLETED) {
            setToastText('お疲れ様でした。この単元の動画終了しました。修了テストを受けていない場合は、修了テストを受けてください。');
            setToastOpen(true);
            return;
          }
          userLesson.watchedTime = lesson.duration;
          userLesson.status = _UserLesson.UserLesson.STATUS_COMPLETED;
          userLesson.completedAt = new Date();
          await userLesson.updateFirebase();
          setUserLesson(new _UserLesson.UserLesson(userLesson));
          setToastText('お疲れ様でした。この単元の受講が完了しました。この単元の修了テストを受けることができます。');
          setToastOpen(true);
        },
        children: [lesson.videoPreviewUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          src: lesson.videoPreviewUrl
        }), "Your browser does not support the video tag."]
      }), !isStarted && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        ...stylex.props(_Style.videoStyle.modal),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.p1b, _Style.videoStyle.modalItem, _Style.textStyle.white),
          children: isLoading ? '読み込み中...' : `単元「${lesson.name}」を開始します。`
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
          ...stylex.props(_Style.buttonStyle.secondary, _Style.videoStyle.modalItem),
          onClick: restart,
          children: "\u53D7\u8B1B\u3092\u958B\u59CB\u3059\u308B"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
          ...stylex.props(_Style.buttonStyle.secondary, _Style.videoStyle.modalItem),
          onClick: () => {
            window.history.back();
          },
          children: "\u623B\u308B"
        })]
      }), isEnd && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        ...stylex.props(_Style.videoStyle.modal),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.p1b, _Style.videoStyle.modalItem, _Style.textStyle.white),
          children: "\u304A\u75B2\u308C\u69D8\u3067\u3057\u305F\u3002\u3053\u306E\u5358\u5143\u306E\u53D7\u8B1B\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u3053\u306E\u5358\u5143\u306E\u4FEE\u4E86\u30C6\u30B9\u30C8\u3092\u53D7\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
          ...stylex.props(_Style.buttonStyle.primary, _Style.videoStyle.modalItem),
          onClick: toExam,
          children: "\u4FEE\u4E86\u30C6\u30B9\u30C8\u3092\u53D7\u3051\u308B"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
          ...stylex.props(_Style.buttonStyle.secondary, _Style.videoStyle.modalItem),
          onClick: restart,
          children: "\u3082\u3046\u4E00\u5EA6\u53D7\u8B1B\u3059\u308B"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
          ...stylex.props(_Style.buttonStyle.secondary, _Style.videoStyle.modalItem),
          onClick: () => {
            window.history.back();
          },
          children: "\u6559\u6750\u4E00\u89A7\u306B\u623B\u308B"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "row",
      alignItems: 'flex-start',
      spacing: 2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
        startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.SkipPrevious, {}),
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: restart,
        children: "\u521D\u3081\u304B\u3089\u518D\u751F"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
        startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.PlayArrow, {}),
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: startWatchedTime,
        children: "\u4E2D\u65AD\u3057\u305F\u3068\u3053\u308D\u304B\u3089\u518D\u751F"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
        startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.Pause, {}),
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: pause,
        children: "\u53D7\u8B1B\u3092\u4E2D\u65AD"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
        startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.AssignmentTurnedIn, {}),
        ...stylex.props(userLesson.isCompleted ? _Style.buttonStyle.primary : _Style.buttonStyle.disabled),
        onClick: toExam,
        disabled: !userLesson.isCompleted,
        children: "\u4FEE\u4E86\u30C6\u30B9\u30C8\u3092\u53D7\u3051\u308B"
      })]
    })]
  });
}; // <div {...stylex.props(chipStyle.common, chipStyle.inactive)}>未受講</div>*/
var _default = exports.default = App;